// extracted by mini-css-extract-plugin
export default {"iconA":"ContactComponents_iconA__Dn0GW","tooltip":"ContactComponents_tooltip__WpwUe"};